import React from "react";
import Icon from "@/components/icons";
import { cn } from "@/lib/utils";
import useTranslations from "@/i18n/useTranslations";
import {
  PROGRAM_RETIRED_MESSAGE,
  PROGRAM_UNAVAILABLE_MESSAGE,
} from "./constants";

interface ProgramRetiredMessageProps {
  className?: string;
  textClassName?: string;
  message?: string;
}

export default function ProgramRetiredMessage({
  className = "",
  textClassName = "",
  message = PROGRAM_RETIRED_MESSAGE,
}: ProgramRetiredMessageProps) {
  const t = useTranslations("Program");
  const displayMessage =
    message === PROGRAM_UNAVAILABLE_MESSAGE
      ? t("programCurrentlyUnavailable")
      : message === PROGRAM_RETIRED_MESSAGE
        ? t("programIsRetired")
        : message;

  return (
    <div
      role="status"
      className={cn("flex items-center gap-2", className)}
      data-testid="program-retired-message"
    >
      <span className={cn("flex shrink-0", textClassName)}>
        <Icon type="warning" svgProps={{ width: "24", height: "24" }} />
      </span>
      <p className={cn("m-0 text-md", textClassName)}>{displayMessage}</p>
    </div>
  );
}
